// Проверка доступности SW-скрипта по URL перед регистрацией (оконная сторона). SPEC pwa-shell §4.3.
//
// Если по swUrl отдаётся не JS (например, статика не содержит /sw.js и SPA-fallback вернул index.html
// с text/html), вызывать navigator.serviceWorker.register нельзя: браузер пишет «unsupported MIME type»
// в консоль ещё ДО reject промиса register(), и оконный .catch это не подавляет. Зонд по content-type
// отсекает такой случай — регистрацию пропускают, приложение работает без офлайн-оболочки.
//
// Сетевой вызов живёт здесь (pwa-shell), а не в app-ui: app-ui по инв.2 не делает сеть в обход
// транспорта, а «есть ли SW в статике» — забота PWA-оболочки.
export async function isServiceWorkerScript(swUrl) {
    if (typeof fetch !== 'function')
        return false;
    try {
        const res = await fetch(swUrl, { method: 'GET', cache: 'no-store' });
        if (!res.ok)
            return false;
        const ctype = res.headers.get('content-type') ?? '';
        return /javascript|ecmascript/i.test(ctype);
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=sw-availability.js.map